import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface OverviewBoxProps {
  isDisabled?: boolean;
  children?: ReactNode;
  onClick?: () => void;
}

/**
 * Visual container for "overview boxes" on the project detail/settings page.
 *
 * - Used to preview things like the job description, assessment criteria, and interview questions in the job type configuration section.
 * - Typically opens the job type editor slideover when clicked.
 * - Looks like a rounded rectangle with a border. Highlights light blue when hovered.
 */
export const OverviewBox: FC<OverviewBoxProps> = (props) => {
  const onClick = !props.isDisabled ? props.onClick : undefined;

  return (
    <div
      className={twMerge(
        "w-fit max-w-full overflow-hidden rounded-lg border border-border-light bg-white text-sm",
        onClick ? "cursor-pointer hover:bg-blue-50" : null,
      )}
      aria-disabled={props.isDisabled}
      onClick={onClick}
    >
      {props.children}
    </div>
  );
};
